// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_vue_vue-loader-v15_lib_runtime_componentNormalizer_js-node_modules_axios-d4e89a"], function() { return __webpack_require__("./src/main.ts"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
